// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"30050c33","977":"e84b5cb6"}[chunkId] + ".chunk.js";
};